import whiteStarPic from '@/assets/images/white-star.png';

export default function AIStrategy() {
  return (
    <div className="py-16 hidden">
      <div className="flex items-center gap-3 mb-12">
        <img src={whiteStarPic} alt="Star" className="h-[24px] sm:h-[28px] md:h-[32px] lg:h-[36px] w-auto" />
        <h2 className="text-3xl font-bold">AI 投资策略</h2>
      </div>
      <div className="max-w-4xl mx-auto">
        <div className="bg-gray-900 p-8 rounded-xl mb-8">
          <h3 className="text-2xl font-bold mb-4">AI 投资理念</h3>
          <p className="text-gray-300 leading-relaxed">
            我们相信人工智能正在重塑各个行业，从医疗健康到金融服务，从教育到交通。
            我们的 AI 投资策略专注于识别和投资那些能够利用 AI 技术创造革命性解决方案的公司。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
          <div className="bg-gray-900 p-6 rounded-xl">
            <h3 className="text-xl font-bold mb-4">投资重点</h3>
            <ul className="text-gray-300 space-y-2">
              <li>• 大语言模型与生成式 AI</li>
              <li>• AI 基础设施与算力</li>
              <li>• AI 应用与垂直领域解决方案</li>
              <li>• AI 安全与伦理</li>
            </ul>
          </div>

          <div className="bg-gray-900 p-6 rounded-xl">
            <h3 className="text-xl font-bold mb-4">投资优势</h3>
            <ul className="text-gray-300 space-y-2">
              <li>• 专业的 AI 研究团队</li>
              <li>• 全球化的投资视野</li>
              <li>• 严格的风险控制</li>
              <li>• 长期价值投资理念</li>
            </ul>
          </div>
        </div>

        <div className="bg-gray-900 p-6 rounded-xl">
          <h3 className="text-xl font-bold mb-4">投资流程</h3>
          <div className="space-y-4">
            <div className="flex items-start gap-4">
              <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center text-white font-bold">1</div>
              <div>
                <h4 className="font-semibold mb-2">市场研究</h4>
                <p className="text-gray-300">深入分析 AI 行业趋势和机会</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center text-white font-bold">2</div>
              <div>
                <h4 className="font-semibold mb-2">项目筛选</h4>
                <p className="text-gray-300">评估潜在投资标的的技术实力和市场潜力</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center text-white font-bold">3</div>
              <div>
                <h4 className="font-semibold mb-2">尽职调查</h4>
                <p className="text-gray-300">全面的技术、团队和财务评估</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center text-white font-bold">4</div>
              <div>
                <h4 className="font-semibold mb-2">投资决策</h4>
                <p className="text-gray-300">基于综合评估做出投资决定</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
